import { AdCreativeWizard } from '@/components/mediaBuying/adCreatives/AdCreativeWizard'

const NewCreative = () => {
    return <AdCreativeWizard />
}

export default NewCreative
